<template>
	<div>
		<v-dialog v-model="dialog_einvoice"v-if="dialog_einvoice && $parent.displayData" no-click-animation persistent transition="dialog-bottom-transition">
			<v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader style="display: flex;flex: 1;">E-Invoice <v-spacer></v-spacer>
                        <v-btn icon @click="closeDialogWeb"><v-icon>close</v-icon></v-btn>
                    </v-subheader>
	        	</v-card-title>
	        	<v-divider></v-divider>
		        <v-card-text full-height>
                    <!-- Generate E-invoice JSON -->

                    <v-layout row wrap margin-top-ten white-background v-if="$parent.displayData.additionalData && $parent.displayData.additionalData.eInvoiceDetails">
                        
                        <v-flex xs12 sm12 md12 mb-3 v-if="$parent.displayData.additionalData.eInvoiceDetails.irnNumber">
                            <div font12 light-theme-color>IRN Number</div>
                            <div font16>{{$parent.displayData.additionalData.eInvoiceDetails.irnNumber}}</div>
						</v-flex>

                        <v-flex xs12 sm12 md12 mb-3 v-if="$parent.displayData.additionalData.eInvoiceDetails.ackNumber">
                            <div font12 light-theme-color>Ack Number</div>
                            <div font16>{{$parent.displayData.additionalData.eInvoiceDetails.ackNumber}}</div>
						</v-flex>

                        <v-flex xs12 sm12 md12 v-if="$parent.displayData.additionalData.eInvoiceDetails.ackDate">
                            <div font12 light-theme-color>Ack Date</div>
                            <div font16>{{$moment($parent.displayData.additionalData.eInvoiceDetails.ackDate).format('DD-MMM-YYYY')}}</div>
						</v-flex>
                    </v-layout>

					<v-layout row wrap v-if="!$parent.displayData.additionalData || (!$parent.displayData.additionalData.eInvoiceDetails.irnNumber && !$parent.displayData.additionalData.eInvoiceDetails.ackNumber && !$parent.displayData.additionalData.eInvoiceDetails.ackDate)">
						<v-flex xs12 sm12 md12>
							E-Invoice not generated yet.
						</v-flex>
					</v-layout>

                    <v-alert type="warning" :value="true" class="mt-4" v-if="$parent.displayData.additionalData && $parent.displayData.additionalData.eInvoiceDetails && $parent.displayData.additionalData.eInvoiceDetails.irnNumber">E-invoice already generated.</v-alert>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
                    <v-layout row wrap>
                        <v-flex xs6 sm6 md6 center-align style="border-right: 1px #ddd solid;">
                            <v-btn small color="blue darken-1" flat @click="$parent.fn_editEInvoice">Edit Details</v-btn>
                        </v-flex>
                        <v-flex xs6 sm6 md6 center-align>
                            <v-btn small color="blue darken-1" flat @click="$parent.fn_downloadJSON($parent.eInvoiceData, 'einvoice')">Generate JSON</v-btn>
                        </v-flex>
                    </v-layout>
		        	<!-- <v-spacer></v-spacer> -->
		        </v-card-actions>
		    </v-card>

	    </v-dialog>
	</div>
</template>

<script>

	export default{
		data(){
			return{
				dialog_einvoice:false,
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_einvoice = true;
			},
			closeDialogWeb: function () {
				this.dialog_einvoice = false;
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/sale/dialogs/dialog_einvoice_confirmation.vue